import { Box, Button, CircularProgress, Typography } from '@mui/material'
import React, { useMemo } from 'react'
import Item from '../../assets/DigitalCoursesAsset/CourseItem.jpg'
import { useGet } from '../../hooks/useApi';
import { useLocation, useParams } from 'react-router-dom';
export default function CourseOrderSummary({onClick}) {
  const { id } = useParams();
  const location = useLocation(); // Access the current location (URL)
  
  // Parse query parameters from the URL
  const queryParams = new URLSearchParams(location.search); // Extract query string
  
  const productId = queryParams.get('productId'); // Get the productId
  const { data: courses, error: coursesErr, isLoading: coursesLoader } = useGet('/api/Courses/all-courses');
  // const [moreCourses, setMoreCourses] = useState([])
  const coursesList = useMemo(() => courses?.data || [], [courses]);
  
  
  const showCourse = coursesList?.find(course => {
    console.log('courseId from list:', course.courseId); // Log each courseId
    console.log('compare', Number(course.courseId) === Number(id) || Number(productId));
    
    return Number(course.courseId) === Number(id) || Number(productId);

  });
  
  

  if (coursesLoader) {
    return <CircularProgress sx={{ display: "block", margin: "20px auto" }} />;
  }
  console.log('s',showCourse);
  
  return (
    <Box sx={{display:'flex', flexDirection:'column',fontFamily: theme=> theme.typography.smallText,}}>  
         <Box sx={{width: '100%', display: 'flex', my: 2, justifyContent:'center', alignItems:'center'}}>
         <img src={showCourse?.courseImagePath} alt="item purchased" style={{width: '170px', height:'120px', borderRadius:'5px'}} />
      </Box>
      {showCourse &&       <Box sx={{border: '1px solid #D2D1D6', borderRadius: '8px', padding: {md: 2, xs: 1}, display:'flex', flexDirection:'column', width:'100%', marginTop: 4}}>
    <Box sx={{borderBottom: '1px solid #D2D1D6', marginBottom: 1, display:'flex', justifyContent:'space-between'}}>
     <Typography sx={{textTransform:'capitalize', fontSize: 13}}>
        Course Purchased
     </Typography>
     <Box sx={{display:'flex', alignItems:'center', gap: {xs: 1, md: 2}, paddingBottom: 1}}>
      
  
       <Typography sx={{textTransform:'capitalize', fontSize: 13}}>{showCourse?.courseTitle}</Typography>
     </Box>
    </Box>
    <Box sx={{borderBottom: '1px solid #D2D1D6', marginBottom: 1, display:'flex', justifyContent:'space-between',marginTop: 1}}>
     <Typography sx={{textTransform:'capitalize',fontSize: 13}}>
     quantity
     </Typography>
     <Typography sx={{fontSize: 13}}>1 Unit</Typography>
    
    </Box>
    <Box sx={{borderBottom: '1px solid #D2D1D6', marginBottom: 1, display:'flex', justifyContent:'space-between',marginTop: 1,fontSize: 12}}>
     <Typography sx={{textTransform:'capitalize',fontSize: 12}}>
     price
     </Typography>
     <Typography sx={{fontSize: 13}}>₦ {showCourse?.price}</Typography>
    
    </Box>
    {/* <Box sx={{borderBottom: '1px solid #D2D1D6', marginBottom: 1, display:'flex', justifyContent:'space-between'}}>
     <Typography sx={{textTransform:'capitalize',fontSize: 15}}>
     order I.D
     </Typography>
     <Typography sx={{fontSize: 13}}>₦10,000</Typography>
    
    </Box> */}
  </Box>}
   
  <Button variant="contained"
                onClick={onClick}
             
                  sx={{width:'100%', mt: 8,display:'flex',  alignItems:'center', gap:1, textTransform:'none','&.Mui-disabled': {
            backgroundColor: 'rgba(86, 4, 246, 0.2)', // Background color when button is disabled
            color: 'rgba(255, 255, 255, 1)', // Text color when button is disabled
          }, color:'rgba(255, 255, 255, 1)', boxShadow:'none', backgroundColor:'rgba(86, 4, 246, 1)', py:1, px:2, minWidth:'fit-content', borderRadius:'100px', ':hover': {
            backgroundColor:'#4f03e7', 
            fontWeight:600,
            boxShadow:'0px 3px 1px -2px rgba(86, 4, 246,0.2),0px 2px 2px 0px rgba(86, 4, 246,0.14),0px 1px 5px 0px rgba(86, 4, 246,0.12)'
          }}}>Continue Checkout</Button>
  </Box>
  )
}
